import { CodeEditor, type CodeEditorProps } from '../../CodeEditor';

export interface EditorProps
  extends Pick<CodeEditorProps, 'onChange' | 'onError' | 'height'> {
  template: string | null;
}

export const Editor = ({
  onChange,
  onError,
  template,
  height,
}: EditorProps) => {
  return (
    <CodeEditor
      height={height}
      value={template || '{}'}
      onChange={onChange}
      language="json"
      onError={onError}
    />
  );
};
